import axios from "axios";
import BASE_URL from "../../../../../assets/global/url";
import { fetchPagedWithDetails } from "../../../../../utils/export/batchFetch";
import { renderPdfInWorker } from "../../../../../utils/export/pdfWorker";
import ExpensesPdf from "./ExpensesPdf";
import exportExpensesExcel from "./expensesExcel";

// Export config for ExportOptionsModal (see components/Export).

const PAGE_SIZE = 200;

// Same status grouping the tabs use. `value` is the status_tab /getExpensesData
// takes; it expands "Approved" to the statuses in `includes` itself.
const STATUSES = [
  { value: "For-Approval", label: "Pending", includes: ["For-Approval"] },
  {
    value: "Approved",
    label: "Approved",
    includes: ["Approved", "Partially-Paid", "Paid"],
  },
];

function toExportExpense(row) {
  return {
    id: row.id,
    client_transaction_id: row.client_transaction_id,
    expenses2: row.expenses2,
    foreign: row.foreign,
    totalAmount: row.totalAmount,
    currency_name: row.currency?.currency_name || "PHP",
    desc: row.desc,
    date_approved: row.date_approved,
    expenses_date: row.expenses_date,
    status: row.status,
  };
}

// filters: { currencyId, userLoggedID } - the user id is required by the
// endpoint, which limits Employees to their own expenses
async function fetchRecords({
  status,
  startDate,
  endDate,
  filters,
  signal,
  onProgress,
}) {
  const { rows } = await fetchPagedWithDetails({
    recordLabel: "expenses",
    signal,
    onProgress,
    fetchPage: async (page) => {
      const res = await axios.get(`${BASE_URL}/expenses/getExpensesData`, {
        params: {
          startDate,
          endDate,
          status_tab: status,
          currencyId: filters?.currencyId,
          userLoggedID: filters?.userLoggedID,
          limit: PAGE_SIZE,
          page,
          // Stable key so rows can't shift between pages mid-export
          sortBy: "id",
          sortDirection: "ASC",
        },
        signal,
      });
      return { rows: res.data.data || [], totalPages: res.data.totalPages };
    },
  });

  // Fetched by id for stable paging; present them latest expense date first
  rows.sort((a, b) =>
    String(b.expenses_date || "").localeCompare(String(a.expenses_date || "")),
  );
  return rows.map(toExportExpense);
}

const expensesExportConfig = {
  title: "Expenses",
  recordLabel: "expenses",
  statuses: STATUSES,
  fetchRecords,
  renderPdf: ({ records, meta, signal }) =>
    renderPdfInWorker({
      createWorker: () =>
        new Worker(new URL("./expensesPdf.worker.jsx", import.meta.url)),
      Document: ExpensesPdf,
      props: { records, meta },
      signal,
    }),
  exportExcel: exportExpensesExcel,
};

export default expensesExportConfig;
